import { location } from '../data/contact';
import './Footer.scss';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <p>
          © {year} Cipher Works · {location}
        </p>
        <p>Crafted for mechanical design, precision fabrication, and electronics integration.</p>
      </div>
    </footer>
  );
}

export default Footer;
